import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Review from './Payment/Review';
import Transaction from './Payment/Transaction';
import { goToPage, pages } from '../states/page/actions';
import { getPage, hasError } from '../states/page/selectors';
import Warnings from './Warning/Warnings';
import { IBActions } from './utils/constants';
import PaymentCancelled from './Warning/PaymentCancelled';
import { getApiError, getNextPage, isEffectiveWarningApplicable, isTransferOrCCPayment } from './state/selectors';
import { getPaymentReasons, goToEWWarning, setAccountDetailsPayeeId } from './state/actions';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

const mapState = (state, props) => ({
	page: getPage(state),
	isEffectiveWarningApplicable: isEffectiveWarningApplicable(state, props.payType),
	isTransferOrCCPayment: isTransferOrCCPayment(state),
	nextPage: getNextPage(state),
	apiError: getApiError(state), // REFACTOR: rename to ewApiError to avoid ambiguity
	hasError: hasError(state),
});

const mapDispatch = (dispatch) => ({
	goToReview: () => dispatch(goToPage(pages.EffectiveWarning.review)),
	goToEWWarning: (payType, onContinue) => dispatch(goToEWWarning(payType, onContinue)),
	getPaymentReasons: () => dispatch(getPaymentReasons()),
	setAccountDetailsPayeeId: (id) => dispatch(setAccountDetailsPayeeId(id)),
});

// REFACTOR: This needs to be split so we aren't using the same component for retail and sme approver flow
class EffectiveWarningContainer extends Component {
	constructor(props) {
		super(props);
		this.handleReviewContinue = this.handleReviewContinue.bind(this);

		const { apiError, page, getPaymentReasons, onContinue } = props;

		if (page === pages.EffectiveWarning.warning && apiError) {
			onContinue();
			return;
		}
		if (page === pages.EffectiveWarning.paymentReason) getPaymentReasons();
	}

	componentDidMount() {
		const { effectiveWarning, setAccountDetailsPayeeId } = this.props;
		setAccountDetailsPayeeId(get(effectiveWarning, 'accountDetails.payee.id'));
	}

	shouldComponentUpdate(nextProps) {
		const { apiError, onContinue, page, goToReview, onAction, hasError } = nextProps;
		if (hasError) {
			onAction(IBActions.ERROR);
			return false;
		}

		if (apiError) {
			switch (page) {
				case pages.EffectiveWarning.paymentReason:
					goToReview();
					return true;
				case pages.EffectiveWarning.warning:
					onContinue();
					return false;
				default:
					return true;
			}
		}
		return true;
	}

	componentDidUpdate(prevProps) {
		const { effectiveWarning, hasError, onAction, setAccountDetailsPayeeId } = this.props;

		if (
			(!isEqual(get(effectiveWarning, 'accountDetails.payee.id')),
			get(prevProps, 'effectiveWarning.accountDetails.payee.id'))
		) {
			setAccountDetailsPayeeId(get(effectiveWarning, 'accountDetails.payee.id'));
		}

		if (hasError) {
			onAction(IBActions.ERROR);
		}
	}

	handleReviewContinue(event) {
		event.preventDefault();
		const { nextPage, onContinue, isBatch, listPayType, batchPayType, goToEWWarning, apiError } = this.props;

		if (nextPage === pages.EffectiveWarning.warning && !apiError) {
			const payType = isBatch ? batchPayType : listPayType;
			goToEWWarning(payType, onContinue);
		} else onContinue();
	}

	render() {
		const { page, onAction, onContinue, goToReview, isEffectiveWarningApplicable, isTransferOrCCPayment } = this.props;
		// REFACTOR: This is a hack to get around isEffectiveWarningApplicable returning false when in the payment auth flow - requires a major refactor to fix
		if (page === pages.EffectiveWarning.paymentReason && (!isEffectiveWarningApplicable || isTransferOrCCPayment)) {
			goToReview();
			return null;
		}

		switch (page) {
			case pages.EffectiveWarning.paymentReason:
				return (
					// REFACTOR: onError does not appear to be used also generic onAction function is not good - refactor to use correct props
					<Transaction onAction={onAction} onContinue={goToReview} onError={() => onAction(IBActions.CANCEL_PAYMENT)} />
				);
			case pages.EffectiveWarning.review:
				return <Review onAction={onAction} onContinue={this.handleReviewContinue} />;
			case pages.EffectiveWarning.warning:
				return (
					// REFACTOR: onError does not appear to be used
					<Warnings onContinue={onContinue} onError={() => onAction(IBActions.CANCEL_PAYMENT)} onAction={onAction} />
				);
			case pages.EffectiveWarning.paymentCancelled:
				return <PaymentCancelled onAction={onAction} />;
			default:
				return null;
		}
	}
}

EffectiveWarningContainer.propTypes = {
	page: PropTypes.string.isRequired,
	onAction: PropTypes.func,
	onContinue: PropTypes.func,
	goToReview: PropTypes.func,
	isEffectiveWarningApplicable: PropTypes.bool,
	isTransferOrCCPayment: PropTypes.bool,
	nextPage: PropTypes.string,
	isBatch: PropTypes.bool,
	listPayType: PropTypes.string,
	batchPayType: PropTypes.string,
	goToEWWarning: PropTypes.func.isRequired,
	apiError: PropTypes.bool,
	hasError: PropTypes.bool,
	getPaymentReasons: PropTypes.func,
};

export default connect(mapState, mapDispatch)(EffectiveWarningContainer);
